(function () {
  'use strict';

  function initPersonalizer(root) {
    if (!root || root.dataset.personalizerReady === 'true') return;
    root.dataset.personalizerReady = 'true';

    var configNode = root.querySelector('[data-personalizer-config]');
    if (!configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('WTA Personalizer configuration could not be parsed.', error);
      return;
    }

    var formats = (config.formats || []).filter(function (item) {
      return item && item.product && Array.isArray(item.product.variants) && item.product.variants.length;
    });

    var form = root.querySelector('[data-wta-form]');
    var formatGrid = root.querySelector('[data-format-grid]');
    var optionGroups = root.querySelector('[data-option-groups]');
    var availability = root.querySelector('[data-availability]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var fileInput = root.querySelector('[data-file-input]');
    var uploadZone = root.querySelector('[data-upload-zone]');
    var uploadTitle = root.querySelector('[data-upload-title]');
    var fileNameNode = root.querySelector('[data-file-name]');
    var quality = root.querySelector('[data-quality]');
    var qualityTitle = root.querySelector('[data-quality-title]');
    var qualityMessage = root.querySelector('[data-quality-message]');
    var summaryFormat = root.querySelector('[data-summary-format]');
    var summaryOptions = root.querySelector('[data-summary-options]');
    var summaryPrice = root.querySelector('[data-summary-price]');
    var mobilePrice = root.querySelector('[data-mobile-price]');
    var mobileBar = root.querySelector('[data-mobile-bar]');
    var submitButtons = root.querySelectorAll('[data-submit], [data-mobile-submit]');
    var formError = root.querySelector('[data-form-error]');
    var stage = root.querySelector('[data-preview-stage]');
    var art = root.querySelector('[data-preview-art]');
    var previewImage = root.querySelector('[data-preview-image]');
    var placeholder = root.querySelector('[data-preview-placeholder]');
    var controls = root.querySelector('[data-preview-controls]');
    var expandButton = root.querySelector('[data-preview-open]');
    var modal = root.querySelector('[data-preview-modal]');
    var modalStage = root.querySelector('[data-modal-stage]');
    var propertyFormat = root.querySelector('[data-property-format]');
    var propertyOptions = root.querySelector('[data-property-options]');
    var propertyDimensions = root.querySelector('[data-property-dimensions]');
    var propertyPreview = root.querySelector('[data-property-preview]');

    var state = {
      formatKey: formats.length ? formats[0].key : '',
      options: [],
      variant: null,
      file: null,
      objectUrl: '',
      imageWidth: 0,
      imageHeight: 0,
      fit: 'cover',
      zoom: 1,
      x: 0,
      y: 0,
      rotation: 0
    };

    function currentFormat() {
      return formats.find(function (item) { return item.key === state.formatKey; }) || null;
    }

    function productOptions(product) {
      return (product.options || []).map(function (option) {
        return typeof option === 'string' ? option : (option && option.name ? option.name : 'Option');
      });
    }

    function availableVariants(product) {
      return (product.variants || []).filter(function (variant) { return variant.available !== false; });
    }

    function lowestAvailableVariant(product) {
      var variants = availableVariants(product);
      var lowest = variants.reduce(function (currentLowest, variant) {
        if (!currentLowest) return variant;
        return Number(variant.price) < Number(currentLowest.price) ? variant : currentLowest;
      }, null);

      return lowest || (product.variants || [])[0] || null;
    }

    function isSizeName(name) {
      return /size|dimension|ölç|ebat|boyut/i.test(String(name));
    }

    function isVisualOption(name) {
      return !isSizeName(name) && /frame|style|finish|material|type|shape|panel|surface|paper|çerçeve|malzeme|şekil/i.test(String(name));
    }

    function uniqueOptionValues(product, index) {
      var seen = [];
      (product.variants || []).forEach(function (variant) {
        var value = variant.options && variant.options[index];
        if (value != null && seen.indexOf(value) === -1) seen.push(value);
      });
      return seen;
    }

    function valueHasAvailableVariant(product, index, value) {
      return availableVariants(product).some(function (variant) {
        return variant.options && variant.options[index] === value;
      });
    }

    function exactVariant(product) {
      return (product.variants || []).find(function (variant) {
        return (variant.options || []).every(function (value, index) {
          return value === state.options[index];
        });
      }) || null;
    }

    function setInitialVariant(product) {
      var variant = lowestAvailableVariant(product);
      state.variant = variant;
      state.options = variant ? (variant.options || []).slice() : [];
    }

    function money(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', {
          style: 'currency',
          currency: config.currency || 'USD'
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + ' ' + (config.currency || 'USD');
      }
    }

    function clearNode(node) {
      while (node && node.firstChild) node.removeChild(node.firstChild);
    }

    function formatVisual(formatKey) {
      var visual = document.createElement('span');
      visual.className = 'wta-pz__format-visual';
      visual.dataset.format = formatKey;
      visual.setAttribute('aria-hidden', 'true');
      return visual;
    }

    function renderFormats() {
      clearNode(formatGrid);

      if (!formats.length) {
        var empty = document.createElement('p');
        empty.className = 'wta-pz__availability is-error';
        empty.textContent = config.labels.productRequired;
        formatGrid.appendChild(empty);
        if (mobileBar) mobileBar.hidden = true;
        return;
      }

      formats.forEach(function (format) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'wta-pz__format-card' + (format.key === state.formatKey ? ' is-active' : '');
        button.dataset.format = format.key;
        button.setAttribute('aria-pressed', format.key === state.formatKey ? 'true' : 'false');
        button.appendChild(formatVisual(format.key));

        var copy = document.createElement('span');
        copy.className = 'wta-pz__format-copy';
        var title = document.createElement('strong');
        title.textContent = format.label;
        var description = document.createElement('small');
        description.textContent = format.description;
        copy.appendChild(title);
        copy.appendChild(description);
        button.appendChild(copy);
        formatGrid.appendChild(button);
      });
    }

    function optionTone(value) {
      var text = String(value).toLowerCase();
      if (/black|siyah/.test(text)) return 'black';
      if (/gold|altın|golden/.test(text)) return 'gold';
      if (/white|beyaz|silver|gümüş/.test(text)) return 'white';
      if (/natural|walnut|wood|ahşap|ceviz/.test(text)) return 'natural';
      if (/oval/.test(text)) return 'oval';
      if (/round|circle|yuvarlak/.test(text)) return 'round';
      if (/texture|fabric|woven|paper|peel/.test(text)) return 'texture';
      return 'neutral';
    }

    function panelCount(value) {
      var text = String(value || '').trim();
      var prefixMatch = text.match(/^(\d+)\s*p\s*:/i);
      if (prefixMatch) return Number(prefixMatch[1]);
      var labelMatch = text.match(/(\d+)\s*panel/i);
      return labelMatch ? Number(labelMatch[1]) : 0;
    }

    function splitOptionLabel(value) {
      var text = String(value).trim();
      var panels = panelCount(text);
      var colonIndex = text.indexOf(':');
      var finish = colonIndex > -1 ? text.slice(colonIndex + 1).trim() : text;

      if (panels > 1 && /gallery\s*wrapped|gallery-wrapped/i.test(finish)) {
        return { main: panels + ' Panel', sub: finish };
      }

      var parts = text.split(/\s*[-–]\s*/);
      return {
        main: parts[0] || text,
        sub: parts.length > 1 ? parts.slice(1).join(' · ') : ''
      };
    }

    function createOptionButton(product, optionName, optionIndex, value) {
      var selected = state.options[optionIndex] === value;
      var visual = isVisualOption(optionName);
      var available = valueHasAvailableVariant(product, optionIndex, value);
      var button = document.createElement('button');
      var label = splitOptionLabel(value);

      button.type = 'button';
      button.className = 'wta-pz__option' + (visual ? ' wta-pz__option--visual' : '') + (selected ? ' is-active' : '');
      button.dataset.optionIndex = String(optionIndex);
      button.dataset.optionValue = value;
      button.disabled = !available;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');

      if (visual) {
        var swatch = document.createElement('span');
        swatch.className = 'wta-pz__option-swatch';
        swatch.dataset.tone = optionTone(value);
        var panels = panelCount(value);
        if (panels > 0) swatch.dataset.panels = String(panels);
        swatch.setAttribute('aria-hidden', 'true');
        button.appendChild(swatch);
      }

      var text = document.createElement('span');
      var main = document.createElement('span');
      main.className = 'wta-pz__option-main';
      main.textContent = label.main;
      text.appendChild(main);

      var sub = document.createElement('span');
      sub.className = 'wta-pz__option-sub';
      sub.textContent = available ? (label.sub || (selected ? config.labels.selected : '')) : config.labels.soldOut;
      text.appendChild(sub);
      button.appendChild(text);
      return button;
    }

    function renderOptions() {
      clearNode(optionGroups);
      var format = currentFormat();
      if (!format) return;

      var product = format.product;
      var names = productOptions(product);

      names.forEach(function (name, index) {
        var fieldset = document.createElement('fieldset');
        fieldset.className = 'wta-pz__option-group';
        var legend = document.createElement('legend');
        var selectedText = state.options[index] || '';
        legend.innerHTML = '<strong></strong><span></span>';
        legend.querySelector('strong').textContent = name;
        legend.querySelector('span').textContent = selectedText ? ' · ' + selectedText : '';
        fieldset.appendChild(legend);

        var list = document.createElement('div');
        list.className = 'wta-pz__option-list' + (isVisualOption(name) ? ' wta-pz__option-list--visual' : '');
        uniqueOptionValues(product, index).forEach(function (value) {
          list.appendChild(createOptionButton(product, name, index, value));
        });
        fieldset.appendChild(list);
        optionGroups.appendChild(fieldset);
      });
    }

    function chooseOption(index, value) {
      var format = currentFormat();
      if (!format) return;
      var product = format.product;
      state.options[index] = value;

      var exact = exactVariant(product);
      if (!exact || exact.available === false) {
        var fallback = availableVariants(product).find(function (variant) {
          return variant.options && variant.options[index] === value;
        });
        if (fallback) state.options = fallback.options.slice();
      }

      state.variant = exactVariant(product);
      renderOptions();
      updateAll();
    }

    function selectedSize() {
      var format = currentFormat();
      if (!format) return '';
      var names = productOptions(format.product);
      var index = names.findIndex(isSizeName);
      if (index === -1 && state.options.length === 1) index = 0;
      return index > -1 ? (state.options[index] || '') : '';
    }

    function sizeNumbers() {
      var value = selectedSize();
      var numbers = String(value).match(/\d+(?:[.,]\d+)?/g) || [];
      if (numbers.length < 2) return null;
      return [Number(numbers[0].replace(',', '.')), Number(numbers[1].replace(',', '.'))];
    }

    function combinedSelection() {
      return ([state.formatKey].concat(state.options)).join(' ').toLowerCase();
    }

    function updatePreviewShape() {
      var format = currentFormat();
      if (!format || !art || !stage) return;
      var text = combinedSelection();
      var shape = /oval/.test(text) ? 'oval' : (/round|circle|yuvarlak/.test(text) ? 'round' : 'rectangle');
      var frame = 'none';
      var panels = '1';
      state.options.some(function (value) {
        var count = panelCount(value);
        if (count === 3 || count === 4 || count === 5) {
          panels = String(count);
          return true;
        }
        return false;
      });
      var texture = /texture|fabric|woven/.test(text) ? 'textured' : 'smooth';

      if (/black|siyah/.test(text)) frame = 'black';
      else if (/gold|altın|golden/.test(text)) frame = 'gold';
      else if (/white|beyaz|silver|gümüş/.test(text)) frame = 'white';
      else if (/natural|walnut|wood|ahşap|ceviz/.test(text)) frame = 'natural';
      else if (/gallery|wrapped|stretched/.test(text)) frame = 'wrapped';
      else if (/rolled|roll/.test(text)) frame = 'rolled';

      var ratio = .75;
      var dimensions = sizeNumbers();
      if (dimensions && dimensions[0] > 0 && dimensions[1] > 0) {
        ratio = dimensions[0] / dimensions[1];
      }
      if (state.formatKey === 'cutting-board' && ratio < 1) ratio = 1 / ratio;
      if (state.formatKey === 'wallpaper') ratio = 1.55;
      ratio = Math.max(.45, Math.min(2.2, ratio));

      stage.dataset.format = state.formatKey;
      art.dataset.shape = shape;
      art.dataset.frame = frame;
      art.dataset.panels = panels;
      art.dataset.texture = texture;
      art.style.setProperty('--art-ratio', String(ratio));
      applyImageTransform();
    }

    function applyImageTransform() {
      if (!previewImage) return;
      previewImage.style.objectFit = state.fit;
      previewImage.style.setProperty(
        '--unused',
        '0'
      );
      art.style.setProperty(
        '--art-transform',
        'translate(' + state.x + '%, ' + state.y + '%) scale(' + state.zoom + ') rotate(' + state.rotation + 'deg)'
      );
      updatePreviewProperty();
    }

    function updatePreviewProperty() {
      if (!propertyPreview) return;
      propertyPreview.value = JSON.stringify({
        fit: state.fit,
        zoom: Math.round(state.zoom * 100) + '%',
        horizontal: state.x,
        vertical: state.y,
        rotation: state.rotation
      });
    }

    function updateProperties() {
      var format = currentFormat();
      if (!format) return;
      propertyFormat.value = format.label;
      propertyOptions.value = productOptions(format.product).map(function (name, index) {
        return name + ': ' + (state.options[index] || '');
      }).join(' | ');
      propertyDimensions.value = state.imageWidth && state.imageHeight ? state.imageWidth + ' × ' + state.imageHeight + ' px' : '';
      updatePreviewProperty();
    }

    function renderSummary() {
      var format = currentFormat();
      if (!format) return;
      summaryFormat.textContent = format.label;
      clearNode(summaryOptions);

      productOptions(format.product).forEach(function (name, index) {
        var row = document.createElement('div');
        var label = document.createElement('span');
        var value = document.createElement('strong');
        label.textContent = name;
        value.textContent = state.options[index] || '—';
        row.appendChild(label);
        row.appendChild(value);
        summaryOptions.appendChild(row);
      });

      var price = state.variant ? money(state.variant.price) : '—';
      summaryPrice.textContent = price;
      if (mobilePrice) mobilePrice.textContent = price;
      if (mobileBar) mobileBar.hidden = false;
    }

    function updateVariant() {
      var format = currentFormat();
      state.variant = format ? exactVariant(format.product) : null;
      if (variantIdInput) variantIdInput.value = state.variant ? state.variant.id : '';

      if (!state.variant) {
        availability.textContent = config.labels.soldOut;
        availability.classList.add('is-error');
      } else if (state.variant.available === false) {
        availability.textContent = config.labels.soldOut;
        availability.classList.add('is-error');
      } else {
        availability.textContent = 'Ready to personalize';
        availability.classList.remove('is-error');
      }
    }

    function updateAll() {
      updateVariant();
      updatePreviewShape();
      renderSummary();
      updateProperties();
      if (state.file && state.imageWidth) updateQuality();
    }

    function selectFormat(key) {
      var format = formats.find(function (item) { return item.key === key; });
      if (!format) return;
      state.formatKey = key;
      setInitialVariant(format.product);
      renderFormats();
      renderOptions();
      updateAll();
    }

    function showError(message) {
      formError.textContent = message;
      formError.hidden = false;
    }

    function clearError() {
      formError.textContent = '';
      formError.hidden = true;
    }

    function setQuality(level, title, message) {
      quality.hidden = false;
      quality.dataset.quality = level;
      qualityTitle.textContent = title;
      qualityMessage.textContent = message;
    }

    function updateQuality() {
      if (!state.imageWidth || !state.imageHeight) return;
      var dimensions = sizeNumbers();
      var detail = state.imageWidth + ' × ' + state.imageHeight + ' px.';

      if (!dimensions || state.formatKey === 'wallpaper') {
        setQuality('warning', 'Image received', detail + ' We will verify the final print resolution before production.');
        return;
      }

      var printW = dimensions[0];
      var printH = dimensions[1];
      var direct = Math.min(state.imageWidth / printW, state.imageHeight / printH);
      var rotated = Math.min(state.imageWidth / printH, state.imageHeight / printW);
      var dpi = Math.round(Math.max(direct, rotated));

      if (dpi >= 150) {
        setQuality('good', 'Excellent image quality', detail + ' Estimated print resolution: ' + dpi + ' DPI.');
      } else if (dpi >= 100) {
        setQuality('warning', 'Usable — we will double-check it', detail + ' Estimated print resolution: ' + dpi + ' DPI.');
      } else {
        setQuality('low', 'Low resolution for this size', detail + ' Estimated print resolution: ' + dpi + ' DPI. Consider a smaller size or a larger image.');
      }
    }

    function revokeObjectUrl() {
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = '';
    }

    function acceptFile(file) {
      clearError();
      if (!file) return;
      var extensionOkay = /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || '');
      var typeOkay = !file.type || /^image\//.test(file.type);

      if (!extensionOkay || !typeOkay) {
        showError('Please upload a JPG, PNG, WebP or HEIC image.');
        fileInput.value = '';
        return;
      }
      if (file.size > Number(config.maxFileBytes || 20971520)) {
        showError('This file is larger than 20 MB. Please choose a smaller image.');
        fileInput.value = '';
        return;
      }

      state.file = file;
      state.imageWidth = 0;
      state.imageHeight = 0;
      revokeObjectUrl();
      state.objectUrl = URL.createObjectURL(file);

      uploadZone.classList.add('is-ready');
      uploadTitle.textContent = 'Image uploaded';
      fileNameNode.textContent = file.name;
      previewImage.src = state.objectUrl;
      previewImage.hidden = false;
      previewImage.alt = file.name;
      art.classList.add('has-image');
      controls.hidden = false;
      expandButton.disabled = false;

      var probe = new Image();
      probe.onload = function () {
        state.imageWidth = probe.naturalWidth;
        state.imageHeight = probe.naturalHeight;
        updateQuality();
        updateProperties();
      };
      probe.onerror = function () {
        setQuality('warning', 'File attached', 'Your browser cannot preview this file format, but the original will still be attached to the order.');
      };
      probe.src = state.objectUrl;
    }

    function syncDroppedFile(file) {
      try {
        var transfer = new DataTransfer();
        transfer.items.add(file);
        fileInput.files = transfer.files;
      } catch (error) {
        /* Some browsers already preserve the dropped FileList. */
      }
      acceptFile(file);
    }

    function openModal() {
      if (!state.objectUrl || !modal || !modalStage) return;
      modalStage.innerHTML = stage.innerHTML;
      modalStage.dataset.format = stage.dataset.format;
      var modalArt = modalStage.querySelector('[data-preview-art]');
      var modalImage = modalStage.querySelector('[data-preview-image]');
      if (modalArt) {
        modalArt.dataset.shape = art.dataset.shape;
        modalArt.dataset.frame = art.dataset.frame;
        modalArt.dataset.panels = art.dataset.panels;
        modalArt.dataset.texture = art.dataset.texture;
        modalArt.style.cssText = art.style.cssText;
        modalArt.classList.add('has-image');
      }
      if (modalImage) {
        modalImage.src = state.objectUrl;
        modalImage.hidden = false;
        modalImage.style.objectFit = state.fit;
      }
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wta-pz-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wta-pz-modal-open');
    }

    formatGrid.addEventListener('click', function (event) {
      var button = event.target.closest('[data-format]');
      if (button) selectFormat(button.dataset.format);
    });

    optionGroups.addEventListener('click', function (event) {
      var button = event.target.closest('[data-option-index]');
      if (!button || button.disabled) return;
      chooseOption(Number(button.dataset.optionIndex), button.dataset.optionValue);
    });

    fileInput.addEventListener('change', function () {
      acceptFile(fileInput.files && fileInput.files[0]);
    });

    ['dragenter', 'dragover'].forEach(function (eventName) {
      uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        uploadZone.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        uploadZone.classList.remove('is-dragging');
      });
    });

    uploadZone.addEventListener('drop', function (event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) syncDroppedFile(file);
    });

    root.querySelectorAll('[data-fit]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.fit = button.dataset.fit;
        root.querySelectorAll('[data-fit]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        applyImageTransform();
      });
    });

    root.querySelectorAll('[data-control]').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.dataset.control === 'zoom') state.zoom = Number(input.value) / 100;
        if (input.dataset.control === 'x') state.x = Number(input.value);
        if (input.dataset.control === 'y') state.y = Number(input.value);
        applyImageTransform();
      });
    });

    var rotateButton = root.querySelector('[data-rotate]');
    if (rotateButton) {
      rotateButton.addEventListener('click', function () {
        state.rotation = (state.rotation + 90) % 360;
        applyImageTransform();
      });
    }

    if (expandButton) expandButton.addEventListener('click', openModal);
    root.querySelectorAll('[data-preview-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    form.addEventListener('submit', function (event) {
      clearError();
      if (!state.variant || state.variant.available === false) {
        event.preventDefault();
        showError(config.labels.productRequired);
        formError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!fileInput.files || !fileInput.files[0]) {
        event.preventDefault();
        showError(config.labels.fileRequired);
        uploadZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      updateProperties();
      submitButtons.forEach(function (button) {
        button.disabled = true;
        button.textContent = config.labels.adding;
      });
    });

    if (formats.length) {
      setInitialVariant(formats[0].product);
      renderFormats();
      renderOptions();
      updateAll();
    } else {
      renderFormats();
    }

    window.addEventListener('pagehide', revokeObjectUrl, { once: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wta-personalizer]').forEach(initPersonalizer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
